export default "__VITE_PUBLIC_ASSET__7c6848b4__"